var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Template' : 'Add Template',
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1000px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('copy-from', {
    attrs: {
      "dataForm": _vm.dataForm,
      "options": _vm.invoiceTemplateList,
      "labelFormatter": function labelFormatter(item) {
        return item.templateName;
      }
    },
    on: {
      "copyFromTrigger": _vm.copyFromTrigger
    }
  })], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Supplier",
      "prop": "supplierId"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    on: {
      "change": _vm.supplierChange
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.supplierList, function (item) {
    return _c('el-option', {
      key: "supplier-".concat(item.id),
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Country",
      "prop": "country"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Country"
    },
    on: {
      "change": _vm.countryChange
    },
    model: {
      value: _vm.dataForm.country,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "country", $$v);
      },
      expression: "dataForm.country"
    }
  }, _vm._l(_vm.countryList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Template Name",
      "prop": "templateName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "e.g. SG-EStar-Standard"
    },
    model: {
      value: _vm.dataForm.templateName,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "templateName", $$v);
      },
      expression: "dataForm.templateName"
    }
  })], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Invoice Type",
      "prop": "invoiceType"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "placeholder": "Invoice Type"
    },
    model: {
      value: _vm.dataForm.invoiceType,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "invoiceType", $$v);
      },
      expression: "dataForm.invoiceType"
    }
  }, _vm._l(_vm.invoiceTypeList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Language",
      "prop": "languageOption"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": "",
      "placeholder": "Language"
    },
    model: {
      value: _vm.dataForm.languageOption,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "languageOption", $$v);
      },
      expression: "dataForm.languageOption"
    }
  }, _vm._l(_vm.languageList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Accounts",
      "prop": "bankAccountIds"
    }
  }, [_vm.dataForm.supplierId ? [_vm.supplierBankAccountList.length > 0 ? [_c('select-bank-account', {
    attrs: {
      "supplierBankAccountList": _vm.supplierBankAccountList
    },
    model: {
      value: _vm.dataForm.bankAccountIds,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "bankAccountIds", $$v);
      },
      expression: "dataForm.bankAccountIds"
    }
  })] : _c('div', {
    staticClass: "notSelectTipBg"
  }, [_c('span', [_vm._v("No bank accounts for this supplier.")])])] : _c('div', {
    staticClass: "notSelectTipBg"
  }, [_c('span', [_vm._v("Select supplier first")])])], 2)], 1)], 1)], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }